import api from '@/libs/axiosInstance';
import type { ApiResponse, MessagingSectionCounters } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import { conversationQueryKeys } from './conversation-query-keys';

export const messagingSectionCountersQueryKey = (brandId: string) =>
  conversationQueryKeys.counters(brandId);

const EMPTY_COUNTERS: MessagingSectionCounters = {
  inbox: 0,
  inboxUnread: 0,
  archived: 0,
  sentEmails: 0,
};

const fetchMessagingSectionCounters = async (): Promise<MessagingSectionCounters> => {
  const response = await api.get<ApiResponse<MessagingSectionCounters>>(
    '/dashboard/messages/section-counters'
  );

  return response.data.data ?? EMPTY_COUNTERS;
};

export const useMessagingSectionCountersQuery = (brandId: string | null | undefined) => {
  return useQuery<MessagingSectionCounters, Error>({
    queryKey: messagingSectionCountersQueryKey(brandId ?? ''),
    queryFn: fetchMessagingSectionCounters,
    staleTime: 1000 * 60,
    enabled: !!brandId,
  });
};
